import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, CircularProgress, Container, Typography } from "@mui/material";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import { Helmet } from "react-helmet";
import ReportOutput from "./components/ReportOutput";
import { getSharedReport } from "./ai-reports-service";

const SharedReport = () => {
    const { token } = useParams();
    const [report, setReport] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        getSharedReport(token)
            .then(setReport)
            .catch(() => setError("This report is not available or the link has expired."))
            .finally(() => setLoading(false));
    }, [token]);

    if (loading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
                <CircularProgress />
            </Box>
        );
    }

    if (error) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
                <Typography color="text.secondary">{error}</Typography>
            </Box>
        );
    }

    return (
        <>
            <Helmet>
                <title>{report?.title ?? "Shared Report"} – Adadot</title>
            </Helmet>
            <Container maxWidth="md" sx={{ py: 6 }}>
                <Typography variant="h5" fontWeight={600} gutterBottom>
                    {report.title}
                </Typography>
                {(report.feedbackSummary?.upCount ?? 0) >= 2 && (
                    <Box display="flex" alignItems="center" gap={0.5} mb={2}>
                        <ThumbUpIcon sx={{ fontSize: 14, color: "success.main" }} />
                        <Typography variant="caption" color="success.main">
                            {report.feedbackSummary.upCount} people found this useful
                        </Typography>
                    </Box>
                )}
                <ReportOutput output={report.output} />
            </Container>
        </>
    );
};

export default SharedReport;
